import "./OurPortfolio.module.css";
import Header from "@/reusable_sections/Header";
import ProtectingOurPlanet from "./sections/ProtectingOurPlanet";
import PhotoshootCategoriesGrid from "./sections/PhotoshootCategoriesGrid";
import BookATable from "./sections/BookATable";
import GamingSocialFooter from "@/reusable_sections/Footer";
import Photoshootcategoriesgrid from "./sections/Photoshootcategoriesgrid";
export default function OurPortfolioPage() {
  return <div>
      <Header />
      <ProtectingOurPlanet />
      <PhotoshootCategoriesGrid />
      <Photoshootcategoriesgrid />
      <BookATable />
      <GamingSocialFooter />
    </div>;
}